import { render, staticRenderFns } from "./SettingsDiamondsSwitcher.vue?vue&type=template&id=3aa028b0&scoped=true&"
import script from "./SettingsDiamondsSwitcher.vue?vue&type=script&lang=js&"
export * from "./SettingsDiamondsSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./SettingsDiamondsSwitcher.vue?vue&type=style&index=0&id=3aa028b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa028b0",
  null
  
)

export default component.exports